<template>
    <div v-if="isLoading" class="loading-overlay">
        <p>Carregando dados...</p>
    </div>

    <div v-if="msgAlerta" class="info-alert row-space">
        {{ msgAlerta }}
    </div>

    <!-- CABEÇALHO DO MODELO -->
    <div class="form-edit-page row-space">
        <div class="row row-space">
            <div class="form-item-char05">
                <label class="label-caption">Código</label>
                <div class="field-label field-label-end">
                    {{ Funcoes.formatInteger(objEdicao.id) }}
                </div>
            </div>

            <div class="form-item-char15">
                <label class="label-caption">Código Processo</label>
                <input type="text" v-model="objEdicao.cdmodelo" maxlength="30" />
            </div>

            <div class="form-item">
                <label class="label-caption">Nome Processo</label>
                <input type="text" v-model="objEdicao.nmprocesso" maxlength="100" />
            </div>

            <div class="form-item-char15">
                <label class="label-caption">Ativo</label>
                <select v-model="objEdicao.ativo">
                    <option value="S">Sim</option>
                    <option value="N">Não</option>
                </select>
            </div>

            <div class="form-item-char15">
                <label class="label-caption">SIM</label>
                <select v-model="objEdicao.cksim">
                    <option value="S">Sim</option>
                    <option value="N">Não</option>
                </select>
            </div>

            <div class="form-item-char15">
                <label class="label-caption">Estabelecimento</label>
                <select v-model="objEdicao.ckestabelecimento">
                    <option value="S">Sim</option>
                    <option value="N">Não</option>
                </select>
            </div>

            <div class="form-item-char15">
                <label class="label-caption">Produto</label>
                <select v-model="objEdicao.ckproduto">
                    <option value="S">Sim</option>
                    <option value="N">Não</option>
                </select>
            </div>

            <div class="form-item-char15">
                <label class="label-caption">Rótulo</label>
                <select v-model="objEdicao.ckrotulo">
                    <option value="S">Sim</option>
                    <option value="N">Não</option>
                </select>
            </div>
        </div>


        <div class="row row-space">
            <div class="form-item">
                <EpMenuProcSelect v-model:idSelecionado="objEdicao.idepmenuproc"></EpMenuProcSelect>
            </div>
            <button type="button" class="btn-confirm" @click="salvarDados">
                Salvar
            </button>

            <button type="button" class="btn-cancel" @click="closeForm">
                Cancelar
            </button>
        </div>


        <div class="row row-space">
            <div class="form-item">
                <textarea
                    v-model="objEdicao.descricao"
                    id="informacoes"
                    maxlength="3000"
                    rows="3"
                    style="resize: none;"
                />
            </div>
        </div>
    </div>



    <div class="proc-layout row-space">
        <ProcEtapaList
            :etapas="lsEtapas"
            :etapa-selecionada="etapaSelecionada"
            @select="etapaSelecionada = $event"
            @nova="novaEtapa"
            @remover="removerEtapa"
        />

        <ProcEtapaEdit
            v-if="etapaSelecionada"
            :etapa="etapaSelecionada"
            :etapas="lsEtapas"
            :ls-ep-doc-modelo="lsEpDocModelo"
            :ls-tp-doc="lsTpDoc"
            @update:etapa="atualizarEtapaSelecionada"
        />

        <div v-else class="info-empty proc-empty">
            Nenhuma etapa cadastrada. Clique em “Nova Etapa” para iniciar.
        </div>
    </div>
</template>


<script setup>
import { Api } from '@/funcoes/apiExport';
import { criarProcModelo } from '@/models/procModelo';
import { onMounted, ref } from 'vue';
import { Funcoes } from '@/funcoes/funcoes';
import { globalStore } from '@/globals';
import { Validar } from '@/funcoes/validacoes';
import '@/assets/css/proc-modelo.css';
import EpMenuProcSelect from '@/components/selects/EpMenuProcSelect.vue';
import ProcEtapaEdit from '@/components/procmodelo/ProcEtapaEdit.vue';
import ProcEtapaList from '@/components/procmodelo/ProcEtapaList.vue';

const emit = defineEmits(['close', 'save']);
const props = defineProps({
    idEdicao: {
        type: Number,
        default: 0
    }
});

const etapaSelecionada  = ref(null);
const isLoading = ref(false);
const lsEpDocModelo = ref([]);
const lsEtapas = ref([]);
const lsTpDoc = ref([]);
const msgAlerta = ref(null);
const objEdicao = ref(criarProcModelo());


function closeForm() {
    emit('close');
}

async function lerDados() {
    try {
        isLoading.value = true;
        msgAlerta.value = null;

        if (props.idEdicao > 0) {
            const req = await Api.getCadastroById('proc_modelo', props.idEdicao);
            Object.assign(objEdicao.value, req[0]);
        } else {
            objEdicao.value.idep = globalStore.idep;
        }

        objEdicao.value.idlogin = globalStore.idlogin;

        // LISTA AUXILIARES
        const reqEpDocModelo = await Api.genericPost('/listas/epdocmodelo', {idep: globalStore.idep, ativo: "S"});
        lsEpDocModelo.value = reqEpDocModelo;
        
        const reqTpDoc = await Api.genericPost('/listas/tpdocs', {idep: globalStore.idep, ativo: "S"});
        lsTpDoc.value = reqTpDoc;


        const lsEpDocFull = await Api.genericGet('/cad/proc_modelo_epdoc/from/modelo', {id: props.idEdicao});
        const lsTpDocFull = await Api.genericGet('/cad/proc_modelo_tpdoc/from/modelo', {id: props.idEdicao});

        const reqEtapas = await Api.genericGet('/cad/proc_modelo_etapa/from/modelo', {id: props.idEdicao});
        lsEtapas.value = (reqEtapas || []).map(e => ({
            ...e,
            _status: 'normal',
            lsEpDoc: (lsEpDocFull || []).filter(x => Number(x.idproc_modelo_etapa) === Number(e.id)),
            lsTpDoc: (lsTpDocFull || []).filter(x => Number(x.idproc_modelo_etapa) === Number(e.id))
        }));

        etapaSelecionada.value = lsEtapas.value[0] || null;

    } catch (error) {
        msgAlerta.value = `ATENÇÃO: Não foi possível acessar dados do servidor: "${error.message}"`;
    } finally {
        isLoading.value = false;
    }
}


async function salvarDados() {
    msgAlerta.value = validarDados();
    if (msgAlerta.value) return;

    try {
        isLoading.value = true;

        const response = await Api.genericPut('/cad/proc_modelo', objEdicao.value);

        if (response.bolok === 1) {
            // if (!objEdicao.value.id && response.id) {
            //     objEdicao.value.id = response.id;
            // }

            await salvarEtapasAlteradas();

            emit('save');
            emit('close');
        } else {
            msgAlerta.value = response.erro;
        }
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}


async function salvarEtapasAlteradas() {
    for (const etapa of lsEtapas.value) {
        if (!etapa._status && etapa.id > 0) {
            const possuiVinculoAlterado =
                etapa.lsEpDoc?.some(x => x._status) ||
                etapa.lsTpDoc?.some(x => x._status);

            if (!possuiVinculoAlterado) continue;
        }

        etapa.idproc_modelo = objEdicao.value.id;
        etapa.idlogin = globalStore.idlogin;

        const etapaPayload = { ...etapa };
        delete etapaPayload.lsEpDoc;
        delete etapaPayload.lsTpDoc;
        delete etapaPayload._status;

        const response = await Api.genericPut('/cad/proc_modelo_etapa', etapaPayload);

        if (response.bolok !== 1) {
            throw new Error(response.erro || 'Erro ao salvar etapa');
        }

        if (!etapa.id && response.id) {
            etapa.id = response.id;
        }

        await salvarVinculosEpDoc(etapa);
        await salvarVinculosTpDoc(etapa);

        etapa._status = null;
    }
}

async function salvarVinculosEpDoc(etapa) {
    for (const item of etapa.lsEpDoc || []) {
        if (!item._status && item.id > 0) continue;

        item.idproc_modelo_etapa = etapa.id;
        item.idlogin = globalStore.idlogin;

        const payload = { ...item };
        delete payload._status;
        delete payload._modelo;

        const response = await Api.genericPut('/cad/proc_modelo_epdoc', payload);

        if (response.bolok !== 1) {
            throw new Error(response.erro || 'Erro ao salvar modelo vinculado');
        }

        if (!item.id && response.id) {
            item.id = response.id;
        }

        item._status = null;
    }
}

async function salvarVinculosTpDoc(etapa) {
    for (const item of etapa.lsTpDoc || []) {
        if (!item._status && item.id > 0) continue;

        item.idproc_modelo_etapa = etapa.id;
        item.idlogin = globalStore.idlogin;

        const payload = { ...item };
        delete payload._status;
        delete payload._tpdoc;

        const response = await Api.genericPut('/cad/proc_modelo_tpdoc', payload);

        if (response.bolok !== 1) {
            throw new Error(response.erro || 'Erro ao salvar tipo de anexo vinculado');
        }

        if (!item.id && response.id) {
            item.id = response.id;
        }

        item._status = null;
    }
}


function validarDados() {
    let r = Validar.texto(objEdicao.value.cdmodelo, 'Informe o código do modelo');
    if (!r.ok) return r.msg;
    r = Validar.texto(objEdicao.value.nmprocesso, 'Informe o nome do modelo');
    if (!r.ok) return r.msg;
    return null;
}



//=============================================================================chat
function atualizarEtapaSelecionada(etapaAtualizada) {
    const index = lsEtapas.value.findIndex(e => {
        if (e.id > 0 && etapaAtualizada.id > 0) {
            return Number(e.id) === Number(etapaAtualizada.id);
        }

        return e.ordem === etapaAtualizada.ordem && e.cdetapa === etapaAtualizada.cdetapa;
    });

    if (index >= 0) {
        lsEtapas.value[index] = etapaAtualizada;
        etapaSelecionada.value = lsEtapas.value[index];
    }
}

function novaEtapa() {
    const ordem = lsEtapas.value.length + 1;

    const nova = {
        _uid: `uid-${Date.now()}-${Math.random().toString(16).slice(2)}`,
        id: 0,
        idproc_modelo: objEdicao.value.id || 0,
        idepdocmodelo_laudo: 0,
        ordem,
        cdetapa: `ETAPA_${ordem}`,
        nmetapa: `Nova Etapa ${ordem}`,
        descricao: '',
        ckinicial: ordem === 1 ? 'S' : 'N',
        ckfinal: 'N',
        ckexige_aprovacao: 'N',
        ckpermite_retorno: 'N',
        ckpermite_anexo: 'S',
        ckpermite_doc: 'S',
        ckpermite_assinatura: 'N',
        idperfil_resp: 0,
        idperfil_aprova: 0,
        id_etapa_aprovada: 0,
        idetapa_avanco2: 0,
        id_etapa_reprovada: 0,
        idetapa_retorno2: 0,
        prazo_dias: 0,
        ativo: 'S',
        idlogin: globalStore.idlogin,

        lsEpDoc: [],
        lsTpDoc: [],
        _status: 'insert'
    };

    lsEtapas.value.push(nova);
    etapaSelecionada.value = nova;
}

function removerEtapa(etapa) {
    if (!etapa) return;

    if (etapa.id > 0) {
        etapa.ativo = 'N';
        etapa._status = 'update';
    } else {
        lsEtapas.value = lsEtapas.value.filter(e => e !== etapa);
    }

    etapaSelecionada.value = lsEtapas.value.find(e => e.ativo !== 'N') || null;
}
//=============================================================================chat-end


onMounted(lerDados);
</script>
